<!-- eslint-disable @angular-eslint/template/mouse-events-have-key-events -->
<div class="search-component-overlay">
  <div
    class="search-component"
    [ngClass]="shouldShowParticipantsList ? 'component-min-height' : 'component-fixed-height'"
  >
    <div class="search-form">
      <form [formGroup]="searchParticipantsForm">
        <mat-form-field
          class="search-participants-field"
          [ngClass]="{ 'outside-label': field._control?.focused || changeLabel }"
          appearance="outline"
          #field
        >
          <mat-icon>search</mat-icon>

          @if (!field._control?.focused && !changeLabel) {
            <mat-label>Search Name, Company, Title</mat-label>
          }
          @if (field._control?.focused || changeLabel) {
            <mat-label>Search</mat-label>
          }
          <input
            #searchInput
            id="searchInput"
            type="text"
            (keyup)="submitSearch($event)"
            aria-label="Search Name, Company, Title"
            formControlName="searchValue"
            matInput
          />
          @if (field._control?.focused || searchParticipantsForm?.get('searchValue')?.value || closeButtonHovering) {
            <button
              (click)="clearInput()"
              (mouseover)="closeButtonHovering = true"
              (mouseout)="closeButtonHovering = false"
              type="button"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </form>
      <div class="search-filters">
        <div class="filter-chip favorite-chip" (click)="switchFavoritesFilter()">
          @if (isFavoriteFilterEnabled()) {
            <mat-icon class="favorite-icon" svgIcon="FAVORITE_STAR_FILL"></mat-icon>
          }
          <span class="filter-chip-title" [ngClass]="{ 'disabled-chip': !isFavoriteFilterEnabled() }">Favorites</span>
          @if (isFavoriteFilterEnabled()) {
            <mat-icon class="close-favorite-icon"> close </mat-icon>
          }
        </div>
      </div>
    </div>

    <!-- Participant Results -->
    @if (filteredList().length > 0) {
      <div class="participants-list">
        <div class="list-header"><h4>Participants</h4></div>
        <div class="list-body">
          @for (participant of filteredList(); track participant.userId) {
            <div class="list-item" (click)="openBadge(participant.userId, participant.color)">
              <span class="flex items-center">
                <profile-picture [user]="participant.userObj" [size]="32" [borderWidth]="'0'"></profile-picture>
                <span class="item-name">{{ participant.name }}</span>
                @if (participantIsFavorite(participant.userId)) {
                  <span class="favorite-container">
                    <mat-icon
                      class="favorite-icon"
                      aria-hidden="false"
                      aria-label="Favorite icon"
                      svgIcon="FAVORITE_STAR_FILL"
                    ></mat-icon>
                  </span>
                }
              </span>
              @if (!!participant.color && newVisualIndicators()) {
                <app-ring-colors-legend [ringContainerPosition]="{ bottom: '30%', right: '5%' }">
                  <div class="legend-dot" style="--color: {{ participant.color }}"></div>
                </app-ring-colors-legend>
              }
            </div>
          }
        </div>
      </div>
    }

    <!-- No Results -->
    @if (noResults()) {
      <div class="participants-list">
        <div class="list-header"><h4>Participants</h4></div>
        <div class="list-body">
          <ng-container>
            <span class="item-name">No Results were found</span>
          </ng-container>
        </div>
      </div>
    }
  </div>
</div>
